@for (part of parsedParts; track $index) {
  @if (part.type === 'text') {
    {{ part.content }}
  }
  @if (part.type === 'reference') {
    <span
       class="inline-block align-middle text-xs font-semibold text-blue-800 dark:text-blue-200 bg-blue-200 dark:bg-blue-900/60 rounded-full px-2 py-0.5 mx-1 cursor-pointer hover:bg-blue-300 dark:hover:bg-blue-800/70 transition-colors"
       [title]="part.tooltipText || ''"
       (click)="handleRefClick(part.statement)">
      {{ part.refIndex }}
    </span>
  }
}

